<template>
  <div class="previewOption">
    <span class="item">
      <input type="radio" name="preview_mode" id="preview_m" value="m" v-model="mode">
      <label for="preview_m"><img src="~@/assets/img/ico_preview_m.png" /></label>
    </span>
    <span class="item">
      <input type="radio" name="preview_mode" id="preview_t" value="t" v-model="mode">
      <label for="preview_t"><img src="~@/assets/img/ico_preview_t.png" /></label>
    </span>
    <span class="item">
      <input type="radio" name="preview_mode" id="preview_w" value="w" v-model="mode">
      <label for="preview_w"><img src="~@/assets/img/ico_preview_w.png" /></label>
    </span>
  </div>
</template>

<script>
export default {
  name: 'PreviewMode',
  props: [
    'previewMode'
  ],
  computed: {
    mode: {
      get () {
        return this.previewMode
      },
      set (val) {
        this.$emit('setPreview', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.previewOption {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  z-index: 99;
  .item {
    display: block;
    border: 1px solid $color-lgrey2;
    border-right: none;
    & + .item {
      border-top: none;
    }
    label {
      display: block;
      position: relative;
      padding: 5px;
      border-left: 4px solid $color-white;
      background-color: $color-white;
      transition: all 0.3s;
      cursor: pointer;
    }
    img {
      width: 40px;
      opacity: 0.4;
    }
    :checked + label {
      border-color: $color-primary;
      img {
        opacity: 0.8;
      }
    }
  }
}
</style>
